export function SettingsDrawer({ open, onClose, rules, setRules, prefs, setPrefs, onResetBankroll }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-md bg-feltDark border-l border-white/10 shadow-2xl overflow-y-auto">
        <div className="px-5 py-4 border-b border-white/10 flex items-center justify-between sticky top-0 bg-feltDark z-10">
          <h2 className="font-display text-xl font-bold">Settings</h2>
          <button onClick={onClose} className="text-white/60 hover:text-white text-2xl leading-none">×</button>
        </div>

        <div className="p-5 space-y-6">
          <Group title="Rules">
            <NumField label="Decks" value={rules.decks} min={1} max={8}
              onChange={(v) => setRules({ ...rules, decks: v })} />
            <Toggle label="Dealer hits soft 17" on={rules.dealerHitsSoft17}
              onChange={(v) => setRules({ ...rules, dealerHitsSoft17: v })}
              hint="H17 is worse for the player by ~0.2%. Most Vegas Strip games are S17." />
            <SelectField label="Blackjack pays" value={rules.blackjackPays}
              options={[{ v: 1.5, l: '3:2 (1.5×) — standard' }, { v: 1.2, l: '6:5 (1.2×) — avoid these games' }]}
              onChange={(v) => setRules({ ...rules, blackjackPays: parseFloat(v) })} />
            <Toggle label="Double after split allowed" on={rules.doubleAfterSplit}
              onChange={(v) => setRules({ ...rules, doubleAfterSplit: v })} />
            <SelectField label="Surrender" value={rules.surrender}
              options={[{ v: 'late', l: 'Late surrender' }, { v: 'none', l: 'Not allowed' }]}
              onChange={(v) => setRules({ ...rules, surrender: v })} />
            <NumField label="Penetration %" value={Math.round(rules.penetration * 100)} min={50} max={90}
              onChange={(v) => setRules({ ...rules, penetration: v / 100 })} hint="When this fraction of the shoe has been dealt, it reshuffles. Higher = more profitable for counters." />
          </Group>

          <Group title="Display">
            <Toggle label="Show count" on={prefs.showCount}
              onChange={(v) => setPrefs({ ...prefs, showCount: v })}
              hint="Reveals running count, true count, and decks remaining. Turn off to practice counting yourself." />
            <Toggle label="Coach feedback" on={prefs.coachOn}
              onChange={(v) => setPrefs({ ...prefs, coachOn: v })}
              hint="Compares every decision to optimal basic strategy with an explanation." />
          </Group>

          <Group title="Bankroll">
            <button onClick={onResetBankroll}
              className="w-full px-4 py-2 rounded bg-rose-600/30 border border-rose-400/40 text-white hover:bg-rose-600/50 transition">
              Reset bankroll to $1,000
            </button>
          </Group>
        </div>
      </div>
    </div>
  );
}

function Group({ title, children }) {
  return (
    <section>
      <h3 className="text-xs uppercase tracking-widest text-white/50 mb-3">{title}</h3>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

function Toggle({ label, on, onChange, hint }) {
  return (
    <div>
      <label className="flex items-center justify-between cursor-pointer select-none">
        <span className="text-sm">{label}</span>
        <span onClick={() => onChange(!on)}
          className={`w-10 h-5 rounded-full relative transition ${on ? 'bg-chip' : 'bg-white/20'}`}>
          <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all ${on ? 'left-5' : 'left-0.5'}`} />
        </span>
      </label>
      {hint && <p className="text-xs text-white/50 mt-1">{hint}</p>}
    </div>
  );
}

function NumField({ label, value, min, max, onChange, hint }) {
  return (
    <div>
      <label className="flex items-center justify-between gap-3">
        <span className="text-sm">{label}</span>
        <input type="number" value={value} min={min} max={max}
          onChange={(e) => onChange(Math.max(min, Math.min(max, parseInt(e.target.value || min, 10))))}
          className="w-20 px-2 py-1 rounded bg-white/10 border border-white/20 text-white text-center" />
      </label>
      {hint && <p className="text-xs text-white/50 mt-1">{hint}</p>}
    </div>
  );
}

function SelectField({ label, value, options, onChange }) {
  return (
    <label className="flex items-center justify-between gap-3">
      <span className="text-sm">{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}
        className="px-2 py-1 rounded bg-white/10 border border-white/20 text-white">
        {options.map((o) => <option key={o.v} value={o.v} className="text-black">{o.l}</option>)}
      </select>
    </label>
  );
}
